const EXTERNAL_IMAGE_PATTERN = /^(https?:|data:|blob:)/i
const BLOG_IMAGE_PREFIX = '/images/blog/'
const WEBP_EXTENSION_PATTERN = /\.webp(?=([?#]|$))/i

export const getBlogImageSrc = (image?: string): string | undefined => {
  const rawImage = image?.trim()
  if (!rawImage) return undefined
  if (EXTERNAL_IMAGE_PATTERN.test(rawImage)) return rawImage

  const [, imagePath = rawImage, suffix = ''] = rawImage.match(/^([^?#]*)([?#].*)?$/) ?? []
  const normalizedPath = imagePath.replace(/\\/g, '/').replace(/^\.\//, '')

  if (normalizedPath.startsWith('/')) {
    if (normalizedPath.startsWith('/public/images/blog/')) {
      return `${BLOG_IMAGE_PREFIX}${normalizedPath.replace(/^\/public\/images\/blog\//, '')}${suffix}`
    }

    return `${normalizedPath}${suffix}`
  }

  const blogImageMatch = normalizedPath.match(/^(?:public\/)?images\/blog\/(.+)$/)
  const fileName = blogImageMatch?.[1] ?? normalizedPath

  return `${BLOG_IMAGE_PREFIX}${fileName}${suffix}`
}

export const getBlogImageFallbackSrc = (image?: string): string | undefined => {
  const imageSrc = getBlogImageSrc(image)
  if (!imageSrc || EXTERNAL_IMAGE_PATTERN.test(imageSrc)) return undefined
  if (!WEBP_EXTENSION_PATTERN.test(imageSrc)) return undefined

  return imageSrc.replace(WEBP_EXTENSION_PATTERN, '.jpg')
}
